Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeStyles = void 0;
var _Normal = require("./Normal");
var _Brand = require("./Brand");
var _Alternative = require("./Alternative");
var _Outlined = require("./Outlined");
var _Link = require("./Link");
var _BrandLink = require("./BrandLink");
var _Icon = require("./Icon");
var _IconOutlined = require("./IconOutlined");
var _Blank = require("./Blank");
var useTypeStyles = exports.useTypeStyles = function useTypeStyles() {
  var _useNormal = (0, _Normal.useNormal)(),
    normal = _useNormal.normal;
  var _useBrand = (0, _Brand.useBrand)(),
    brand = _useBrand.brand;
  var _useAlternative = (0, _Alternative.useAlternative)(),
    alternative = _useAlternative.alternative;
  var _useOutlined = (0, _Outlined.useOutlined)(),
    outlined = _useOutlined.outlined;
  var _useLink = (0, _Link.useLink)(),
    link = _useLink.link;
  var _useBrandLink = (0, _BrandLink.useBrandLink)(),
    brandLink = _useBrandLink.brandLink;
  var _useIcon = (0, _Icon.useIcon)(),
    icon = _useIcon.icon;
  var _useIconOutlined = (0, _IconOutlined.useIconOutlined)(),
    iconOutlined = _useIconOutlined.iconOutlined;
  var _useBlank = (0, _Blank.useBlank)(),
    blank = _useBlank.blank;
  var typeStyles = {
    normal: normal,
    brand: brand,
    alternative: alternative,
    outlined: outlined,
    link: link,
    brandLink: brandLink,
    icon: icon,
    iconOutlined: iconOutlined,
    blank: blank
  };
  return {
    typeStyles: typeStyles
  };
};